document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.getElementById("payment-popup-trigger");
  const popup = document.getElementById("payment-popup");
  const overlay = document.getElementById("payment-popup-overlay");
  const closeBtn = document.getElementById("payment-popup-close");

  if (!trigger || !popup || !overlay || !closeBtn) {
    console.warn("Payment popup: missing elements.");
    return;
  }

  // OPEN POPUP
  trigger.addEventListener("click", function () {
    popup.classList.add("active");
    overlay.classList.add("active");
    document.body.classList.add("no-scroll");
  });

  // CLOSE POPUP
  closeBtn.addEventListener("click", function () {
    popup.classList.remove("active");
    overlay.classList.remove("active");
    document.body.classList.remove("no-scroll");
  });

  // CLICK OUTSIDE = CLOSE
  overlay.addEventListener("click", function () {
    popup.classList.remove("active");
    overlay.classList.remove("active");
    document.body.classList.remove("no-scroll");
  });
});
